import React, { useEffect, useRef, useState } from 'react';
import LoadingBox from '../components/LoadingBox';
import axios from 'axios';
import { Helmet } from 'react-helmet-async';
import { Modal, Button } from 'react-bootstrap';
import CanvasBG from '../components/CanvasBG';
import AboutUs from '../components/AboutUs';

export default function HomeScreen(props) {
  const lang = props.lang || 'el'
  const loading = false;
  const [showModal, setShowModal] = useState(false);
  const [modalInfo, setModalInfo] = useState({});
  
  const divRef = useRef();
  const canvasRef = useRef();

  const handleLabelClick = (info) => {
    setModalInfo(info);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setModalInfo({});
    setShowModal(false);
  };

  return (
    <div>
      <div>
        <Helmet>
          <title>Ikeke</title>
        </Helmet>
        {loading ? (
          <LoadingBox />
        ) : (
          <>
            <div ref={canvasRef} id="canvas-container" className="hero-section">
              <CanvasBG handleLabelClick={handleLabelClick} divRef={divRef} showModal={showModal} canvasRef={canvasRef} />
            </div>
            <AboutUs ref={divRef} lang={lang}/>
            <Modal show={showModal} onHide={handleCloseModal}>
              <Modal.Header closeButton>
                <Modal.Title>{modalInfo.title}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                This is the modal content triggered by the label click.
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseModal}>
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          </>
        )}
      </div>
    </div>
  );
}
